/* eslint-disable no-use-before-define */
import { Map } from 'immutable';
import getIn from 'lodash/get';

import { ApiActions } from '../../constants/ApiActions';
import { getPandoraIdFromMusicId } from '../../lib/PandoraIdUtil';
import { createReducer } from '../../lib/ReducerUtils';

const INITIAL_STATE = Map({});

// LYRICS ENTITY REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.FETCH_FULL_LYRICS_SUCCESS]: saveLyricData,
});

// CASE FUNCTIONS

function saveLyricData(state, action) {
  const pandoraId = getPandoraIdFromMusicId(getIn(action, 'params.content.trackUid'));
  const lyrics = getIn(action, 'response.entities.lyrics', {});
  const lyricData = Object.values(lyrics)[0];
  if (lyricData) {
    return state.mergeDeep({ [pandoraId]: lyricData });
  }
  return state;
}
